import {Component, Input} from '@angular/core';
import {DisplayService} from '@app/presentation/services/display.service';

@Component({
  selector: 'app-product-labels',
  templateUrl: './product-labels.component.html',
  styleUrls: ['./product-labels.component.scss']
})
export class ProductLabelsComponent {

  @Input() isNew?: boolean = false;
  @Input() isTopProducts?: boolean = false;
  @Input() isPromotion?: boolean = false;
  @Input() withoutStock?: boolean = false;

  isMobile$ = this.displayService.isMobileDisplay$;

  constructor(
    private displayService: DisplayService
  ) { }

}
